var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('bank-account-form',{attrs:{"model":_vm.bankAccount,"titlePrefix":_vm.$t('bank-account.create.texts.title-prefix'),"reseller_id":_vm.reseller_id},on:{"saved":_vm.saved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }